'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var nanoid = require('nanoid');
var polished = require('polished');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var radioSize = '18px';
var RadioLabel = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  padding-left: ", ";\n  font-weight: 400;\n  font-size: 0.875rem;\n\n  ", ";\n"])), polished.math("".concat(radioSize, " + 10px")), function (props) {
  return props.theme.themeProp('color', props.theme.getColor('gray-300'), props.theme.getColor('gray-600'));
});
var Radio$1 = styled__default['default'].label.attrs(defaultTheme.applyDefaultTheme)(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  cursor: pointer;\n  line-height: ", ";\n  user-select: none;\n\n  &::before {\n    content: '';\n    position: absolute;\n    border: 2px solid ", ";\n    width: ", ";\n    height: ", ";\n    top: 0;\n    border-radius: 50%;\n    transition: all 200ms;\n    box-sizing: border-box;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    top: 5px;\n    left: 5px;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: all 200ms;\n  }\n\n  &:has(input:checked) {\n    ::before {\n      border-color: ", ";\n    }\n\n    ::after {\n      background: ", ";\n      transform: scale(1);\n    }\n\n    ", " {\n      opacity: 1;\n    }\n  }\n  & {\n    input[type='radio'] {\n      position: absolute;\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n\n  ", "\n\n  ", "\n"])), radioSize, function (props) {
  return props.theme.getColor('gray-300');
}, radioSize, radioSize, function (props) {
  return props.theme.getColor('emerald-500');
}, function (props) {
  return props.theme.getColor('emerald-500');
}, RadioLabel, function (props) {
  return props.readOnly && styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      pointer-events: none;\n      user-select: text;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n      user-select: text;\n    "])));
});

var Radio = React__default['default'].forwardRef(function Radio(_ref, forwardedRef) {
  var name = _ref.name,
      value = _ref.value,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      label = _ref.label,
      className = _ref.className,
      style = _ref.style,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      rest = defaultTheme._objectWithoutProperties(_ref, ["name", "value", "checked", "defaultChecked", "disabled", "readOnly", "label", "className", "style", "onChange", "onBlur"]);

  var _useState = React.useState(nanoid.nanoid()),
      _useState2 = defaultTheme._slicedToArray(_useState, 1),
      uniqueId = _useState2[0];

  return React__default['default'].createElement(Radio$1, {
    htmlFor: uniqueId,
    disabled: disabled,
    readOnly: readOnly,
    className: className,
    style: style
  }, React__default['default'].createElement("input", defaultTheme._extends({
    ref: forwardedRef,
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    readOnly: readOnly,
    id: uniqueId,
    onChange: onChange,
    onBlur: onBlur
  }, rest)), React__default['default'].createElement(RadioLabel, null, label));
});
Radio.propTypes = process.env.NODE_ENV !== "production" ? {
  label: defaultTheme.PropTypes.any,
  name: defaultTheme.PropTypes.string.isRequired,
  value: defaultTheme.PropTypes.any.isRequired,
  checked: defaultTheme.PropTypes.bool,
  defaultChecked: defaultTheme.PropTypes.bool,
  disabled: defaultTheme.PropTypes.bool,
  readOnly: defaultTheme.PropTypes.bool,
  className: defaultTheme.PropTypes.string,
  style: defaultTheme.PropTypes.object,
  onChange: defaultTheme.PropTypes.func,
  onBlur: defaultTheme.PropTypes.func
} : {};
Radio.defaultProps = {
  disabled: false
};

exports.Radio = Radio;
